var exports = {
  "sR": "xdbfd91f1--619a79--fotorama",
  "kJ": "xdbfd91f1--619a79--default_content",
  "u1": "xdbfd91f1--619a79--spinner",
};

module.exports = exports;
